"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisposableLazy = exports.Lazy = void 0;
var Lazy = /** @class */ (function () {
    function Lazy(getFunc) {
        this.getFunc = getFunc;
    }
    Lazy.prototype.value = function () {
        var _this = this;
        if (!this.valuePromise) {
            this.valuePromise = this.getFunc().then(function (value) {
                _this.valueCreated = true;
                return value;
            });
        }
        return this.valuePromise;
    };
    Lazy.prototype.isValueCreated = function () {
        return this.valueCreated;
    };
    return Lazy;
}());
exports.Lazy = Lazy;
var DisposableLazy = /** @class */ (function (_super) {
    __extends(DisposableLazy, _super);
    function DisposableLazy(getFunc, disposeFunc) {
        var _this = _super.call(this, getFunc) || this;
        _this.disposeFunc = disposeFunc;
        return _this;
    }
    DisposableLazy.prototype.value = function () {
        if (this.disposed) {
            throw new Error("lazy value is disposed");
        }
        return _super.prototype.value.call(this);
    };
    DisposableLazy.prototype.dispose = function () {
        if (this.isValueCreated()) {
            this.value().then(function (disposable) { return disposable.dispose(); });
        }
        else {
            this.disposeFunc();
        }
        this.disposed = true;
    };
    DisposableLazy.prototype.isDisposed = function () {
        return this.disposed;
    };
    return DisposableLazy;
}(Lazy));
exports.DisposableLazy = DisposableLazy;
